import { ActionIcon } from "@mantine/core";
import { IconEye, IconEyeOff, IconTrash, IconArrowBackUp } from "@tabler/icons-react";
import { Text } from "@mantine/core";
import { Badge } from "@mantine/core";

interface ActionRowProps {
  index: number;
  letter: string;
  isSelected?: boolean;
  isHidden?: boolean;
  isDeleted?: boolean;
  userDrawn?: boolean;
  onView?: (index: number) => void;
  onDelete?: (index: number, isUserDrawn?: boolean) => void;
  onRestore?: (index: number) => void;
}

export const ActionRow = ({
  index,
  letter,
  isSelected,
  isHidden,
  isDeleted,
  userDrawn,
  onView,
  onDelete,
  onRestore,
}: ActionRowProps) => {
  return (
    <div
      key={index}
      className={`flex justify-between items-center gap-4 p-2 rounded ${isSelected && !isDeleted ? "bg-blue-50 border border-blue-200" : ""
        } ${isHidden ? "opacity-50" : ""} ${isDeleted ? "opacity-60" : ""}`}
    >
      <div className="flex gap-2 items-center">
        <Text fw={600} td={isDeleted ? "line-through" : undefined} c={isDeleted ? "dimmed" : undefined}>{letter}</Text>
        {!userDrawn && <Badge color={isDeleted ? "gray" : undefined}>AUTO</Badge>}
      </div>
      <div className="flex gap-2 items-center">
        {isDeleted ? (
          <ActionIcon
            variant="transparent"
            color="blue"
            onClick={(e) => {
              e.stopPropagation();
              onRestore?.(index);
            }}
            title="Restore box"
          >
            <IconArrowBackUp size={18} />
          </ActionIcon>
        ) : (
          <>
            <ActionIcon
              variant="transparent"
              color={isHidden ? "red" : isSelected ? "blue" : "gray"}
              onClick={(e) => {
                e.stopPropagation();
                onView?.(index);
              }}
              title={isHidden ? "Show box" : "Hide box"}
            >
              {isHidden ? <IconEyeOff size={18} /> : <IconEye size={18} />}
            </ActionIcon>
            <ActionIcon
              className="hover:fill-red"
              variant="transparent"
              color="gray"
              onClick={(e) => {
                e.stopPropagation();
                onDelete?.(index, userDrawn);
              }}
              title="Delete box"
            >
              <IconTrash
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "red";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "";
                }}
                className="hover:fill-red"
                size={18}
              />
            </ActionIcon>
          </>
        )}
      </div>
    </div>
  );
};
